export default  {
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Purpose & Impact Report Season 2025",
  "shortTitle": "",
  "description": "",
  "width": 1263,
  "height": 893,
  "currentLanguage": "EN",
    "languages": [{
      "code": "EN",
      "text": "English",
      "href": "http://purpose-impact.sailgp.com/season2025" 
      }
    ],
  "basePath": "/season2025",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "http://purpose-impact.sailgp.com/season2025/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/season2025/static/_content/SailGP_Purpose&Impact_Report_Season2025.pdf',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true,
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true,
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true,
  },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 1-title" style="top:33px;left:50px" src="/season2025/static/_content/1-title-1.png" />
        <img class="halfScale 1-title" style="top:34px;left:501px" src="/season2025/static/_content/1-title-2.png" />
        <img class="halfScale 1-title" style="top:75px;left:499px" src="/season2025/static/_content/1-title-3.png" />
        
        `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.staggerFromTo(cOf("1-title"), 0.6, {opacity:0, x:60}, {opacity:1, x:0}, 0.3, 1)
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 2-text" style="top:50px;left:54px" src="/season2025/static/_content/2-title-1.png" />
        <img class="halfScale 2-text" style="top:124px;left:695px" src="/season2025/static/_content/2-text-1.png" />
        <img class="halfScale 2-text" style="top:229px;left:695px" src="/season2025/static/_content/2-text-2.png" />
        <img class="halfScale 2-text" style="top:334px;left:695px" src="/season2025/static/_content/2-text-3.png" />
        <img class="halfScale 2-text" style="top:461px;left:695px" src="/season2025/static/_content/2-text-4.png" />

        <div class="addContentLink" onclick="Publish.goToPage(3);" style="top:119px; left:692px; width:405px; height:19px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(4);" style="top:141px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(5);" style="top:163px; left:716px; width:378px; height:20px;"></div>

        <div class="addContentLink" onclick="Publish.goToPage(6);" style="top:225px; left:692px; width:405px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(7);" style="top:246px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(8);" style="top:267px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(9);" style="top:287px; left:716px; width:378px; height:20px;"></div>
  
        <div class="addContentLink" onclick="Publish.goToPage(10);" style="top:330px; left:692px; width:405px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(11);" style="top:352px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(12);" style="top:373px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(13);" style="top:393px; left:716px; width:378px; height:20px;"></div>

        <div class="addContentLink" onclick="Publish.goToPage(14);" style="top:458px; left:692px; width:405px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(15);" style="top:479px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(16);" style="top:499px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(17);" style="top:520px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(18);" style="top:542px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(19);" style="top:562px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(20);" style="top:583px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(21);" style="top:604px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(22);" style="top:625px; left:716px; width:378px; height:20px;"></div>
        <div class="addContentLink" onclick="Publish.goToPage(23);" style="top:646px; left:716px; width:378px; height:20px;"></div>
  
      
        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>

      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim.staggerFromTo(cOf("2-text"), 0.5, {opacity:0, x:60}, {opacity:1, x:0, onComplete: addContentLinks}, 0.2, 1)
        }

        function onPageLeave() {
          pg2Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 3-title" style="top:553px;left:29px" src="/season2025/static/_content/3-title-1.png" />
        <img class="halfScale 3-title" style="top:798px;left:486px" src="/season2025/static/_content/3-title-2.png" />

      `,
      "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();
          pg3Anim.staggerFromTo(cOf("3-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1)
        }

        function onPageLeave() {
          pg3Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 4-title" style="top:49px;left:51px" src="/season2025/static/_content/4-title-1.png" />


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>

      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          pg4Anim.staggerFromTo(cOf("4-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1)
        }

        function onPageLeave() {
          pg4Anim.stop();
          removeContentLinks();
        }
    
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 5-title" style="top:50px;left:50px" src="/season2025/static/_content/5-title-1.png" />

        <h1 class="abs fg-semiBdIt 5-no" style="top:204px; left:50px; font-size:3.6em; color: #000000; padding: 0px; margin:0px;" data-number='{"to": 48}' ></h1>
        <h1 class="abs fg-semiBdIt 5-no" style="top:310px; left:48px; font-size:3.6em; color: #000000; padding: 0px; margin:0px;" data-number='{"to": 126}' ></h1>

        <h1 class="abs fg-semiBdIt 5-no" style="top:241px; left:734px; font-size:3.6em; color: #0ad1d1; padding: 0px; margin:0px;" data-number='{"to": 11383, "comma" : true }' ></h1>
        <h1 class="abs fg-semiBdIt 5-no" style="top:341px; left:734px; font-size:3.6em; color: #0ad1d1; padding: 0px; margin:0px;" data-number='{"to": 34132, "comma" : true }' ></h1>
        <h1 class="abs fg-semiBdIt 5-no" style="top:425px; left:734px; font-size:3.6em; color: #0ad1d1; padding: 0px; margin:0px;" data-number='{"to": 6102, "comma" : true }' ></h1>

        <img class="abs halfScaleC 5-chart" style="top:532px;left:270px;" src="/season2025/static/_content/5-piechart-1.png"/>
        <h1 class="abs fg-semiBdIt 5-no" style="top:648px; left:377px; font-size:2.8em; color: #66c1c4; padding: 0px; margin:0px;" data-number='{"to": 42 }' ></h1>
        <img class="abs halfScaleC 5-percentage" style="top:654px;left:415px;" src="/season2025/static/_content/5-perc-1.png"/>
        <img class="abs halfScaleC 5-chart" style="top:532px;left:458px;" src="/season2025/static/_content/5-piechart-2.png"/>
        <h1 class="abs fg-semiBdIt 5-no" style="top:648px; left:573px; font-size:2.8em; color: #66c1c4; padding: 0px; margin:0px;" data-number='{"to": 15 }' ></h1>
        <img class="abs halfScaleC 5-percentage" style="top:654px;left:598px;" src="/season2025/static/_content/5-perc-1.png"/>
        <img class="abs halfScaleC 5-chart" style="top:532px;left:634px" src="/season2025/static/_content/5-piechart-3.png"/>
        <h1 class="abs fg-semiBdIt 5-no" style="top:648px; left:751px; font-size:2.8em; color: #66c1c4; padding: 0px; margin:0px;" data-number='{"to": 5 }' ></h1>
        <img class="abs halfScaleC 5-percentage" style="top:654px;left:762px;" src="/season2025/static/_content/5-perc-1.png"/>

        <h1 class="abs fg-semiBdIt 5-no" style="top:695px; left:896px; font-size:3.6em; color: #f7f537; padding: 0px; margin:0px;" data-number='{"to": 8 }' ></h1>
        <h1 class="abs fg-semiBdIt 5-no" style="top:721px; left:1052px; font-size:3.6em; color: #f7f537; padding: 0px; margin:0px;" data-number='{"to": 17 }' ></h1>

        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim.staggerFromTo(cOf("5-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1)
          .fromTo(cOf("5-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[0])}}, 1.0)
          .fromTo(cOf("5-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[1])}}, 1.1)
          .fromTo(cOf("5-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[2])}}, 1.0)
          .fromTo(cOf("5-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[3])}}, 1.1)
          .fromTo(cOf("5-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[4])}}, 1.2)
          .fromTo(cOf("5-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[5])}}, 1.2)
          .fromTo(cOf("5-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[6])}}, 1.2)
          .staggerFromTo(cOf("5-chart"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.1)
          .fromTo(cOf("5-no")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[7])}}, 1.2)
          .fromTo(cOf("5-no")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[8])}}, 1.0)
          .fromTo(cOf("5-no")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("5-no")[9])}}, 1.1)
          .staggerFromTo(cOf("5-percentage"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.4);
        }

        function onPageLeave() {
          pg5Anim.stop();
          resetNumbers("5-no");
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 6-title" style="top:543px;left:19px" src="/season2025/static/_content/6-title-1.png" />
        <img class="halfScale 6-title" style="top:699px;left:625px" src="/season2025/static/_content/6-title-2.png" />

      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim.staggerFromTo(cOf("6-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1)
        }

        function onPageLeave() {
          pg6Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 7-title" style="top:49px;left:50px" src="/season2025/static/_content/7-title-1.png" />
        <img class="halfScaleC 7-lines" style="top:-58px;left:873px" src="/season2025/static/_content/7-lines-1.png" />
        <img class="halfScaleC 7-click" style="top:158px;left:923px" src="/season2025/static/_content/7-click-1.png" />


        <!-- tab-1 pop-1 -->

        <img class="abs halfScaleC pointer 7-tab" style="top:100px;left:945px" onclick="showSevenPopOne()" src="/season2025/static/_content/7-tab-1.png" />
        <div id="7-pop-1" class="standardTransition contentOverlay hidden noclick">
            <img class="abs halfScale 7-pop-1" style="top:31px;left:575px;" src="/season2025/static/_content/7-pop-1.png"/>
            <div class="abs contentLinkNone pointer" style="top:751px;left:1156px;width:37px;height:37px;" onclick="hideOverlay('7-pop-1')"></div>
        </div> 


        <!-- tab-2 pop-2 -->

        <img class="abs halfScaleC pointer 7-tab" style="top:166px;left:945px" onclick="showSevenPopTwo()" src="/season2025/static/_content/7-tab-2.png" />
        <div id="7-pop-2" class="standardTransition contentOverlay hidden noclick">
            <img class="abs halfScale 7-pop-2" style="top:31px;left:575px;" src="/season2025/static/_content/7-pop-2.png"/>
            <div class="abs contentLinkNone pointer" style="top:751px;left:1156px;width:37px;height:37px;" onclick="hideOverlay('7-pop-2')"></div>
        </div>


        <!-- tab-3 pop-3 -->

        <img class="abs halfScaleC pointer 7-tab" style="top:232px;left:945px" onclick="showSevenPopThree()" src="/season2025/static/_content/7-tab-3.png" />
        <div id="7-pop-3" class="standardTransition contentOverlay hidden noclick">
            <img class="abs halfScale 7-pop-3" style="top:31px;left:575px;" src="/season2025/static/_content/7-pop-3.png"/>
            <div class="abs contentLinkNone pointer" style="top:751px;left:1156px;width:37px;height:37px;" onclick="hideOverlay('7-pop-3')"></div>
        </div>


        <!-- tab-4 pop-4 -->

        <img class="abs halfScaleC pointer 7-tab" style="top:298px;left:945px" onclick="showSevenPopFour()" src="/season2025/static/_content/7-tab-4.png" />
        <div id="7-pop-4" class="standardTransition contentOverlay hidden noclick">
            <img class="abs halfScale 7-pop-4" style="top:31px;left:575px;" src="/season2025/static/_content/7-pop-4.png"/>
            <div class="abs contentLinkNone pointer" style="top:751px;left:1156px;width:37px;height:37px;" onclick="hideOverlay('7-pop-4')"></div>
        </div>


        <!-- tab-5 pop-5 -->

        <img class="abs halfScaleC pointer 7-tab" style="top:365px;left:945px" onclick="showSevenPopFive()" src="/season2025/static/_content/7-tab-5.png" />
        <div id="7-pop-5" class="standardTransition contentOverlay hidden noclick">
            <img class="abs halfScale 7-pop-5" style="top:31px;left:575px;" src="/season2025/static/_content/7-pop-5.png"/>
            <div class="abs contentLinkNone pointer" style="top:751px;left:1156px;width:37px;height:37px;" onclick="hideOverlay('7-pop-5')"></div>
        </div>


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>

      `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim.fromTo(cOf("7-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1)
          .fromTo(cOf("7-lines"), 0.6, {opacity:0, x:60}, {opacity:1, x:0}, 1.3)
          .staggerFromTo(cOf("7-tab"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.5);
        }

          function showSevenPopOne() {
            showOverlay('7-pop-1')
          }
        
          function closeSevenPopOne(){
            hideOverlay('7-pop-1')
          }

          function showSevenPopTwo() {
            showOverlay('7-pop-2')
          }
        
          function closeSevenPopTwo(){
            hideOverlay('7-pop-2')
          }

          function showSevenPopThree() {
            showOverlay('7-pop-3')
          }
        
          function closeSevenPopThree(){
            hideOverlay('7-pop-3')
          }

          function showSevenPopFour() {
            showOverlay('7-pop-4')
          }
        
          function closeSevenPopFour(){
            hideOverlay('7-pop-4')
          }

          function showSevenPopFive() {
            showOverlay('7-pop-5')
          }
        
          function closeSevenPopFive(){
            hideOverlay('7-pop-5')
          }

        function onPageLeave() {
          pg7Anim.stop();
          closeSevenPopOne();
          closeSevenPopTwo();
          closeSevenPopThree();
          closeSevenPopFour();
          closeSevenPopFive();
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 8-title" style="top:49px;left:50px" src="/season2025/static/_content/8-title-1.png" />
        <img class="halfScaleC 8-arrow" style="top:106px;left:32px" src="/season2025/static/_content/8-arrow-1.png" />


        <!-- tab-1 pop-1 -->

        <img class="abs halfScaleC pointer 8-tab" style="top:-42px;left:22px" onclick="showEightPopOne()" src="/season2025/static/_content/8-tab-1.png" />
        <div id="8-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 8-pop-1" style="top:11px;left:11px;" src="/season2025/static/_content/8-pop-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:33px;left:1193px;width:37px;height:37px;" onclick="hideOverlay('8-pop-1')"></div>

          <!-- animations -->

          <h1 class="abs fg-semiBdIt 8-no" style="top:458px;left:349px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 4139, "comma" : true, "append": "kg"}' ></h1>
          <h1 class="abs fg-semiBdIt 8-no" style="top:548px;left:349px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 40}' ></h1>
          <img class="abs halfScaleC 8-plus" style="top:553px;left:388px;" src="/season2025/static/_content/8-plus-1.png"/>
          <h1 class="abs fg-semiBdIt 8-no" style="top:690px;left:349px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 30000, "comma": true }' ></h1>
        </div> 


        <!-- tab-2 pop-2 -->

        <img class="abs halfScaleC pointer 8-tab" style="top:-42px;left:515px" onclick="showEightPopTwo()" src="/season2025/static/_content/8-tab-2.png" />
        <div id="8-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 8-pop-2" style="top:11px;left:11px;" src="/season2025/static/_content/8-pop-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:33px;left:1193px;width:37px;height:37px;" onclick="hideOverlay('8-pop-2')"></div>
          
          <!-- animations -->

          <h1 class="abs fg-semiBdIt 8-no" style="top:463px;left:349px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 80}' ></h1>
          <img class="abs halfScaleC 8-plus" style="top:468px;left:387px;" src="/season2025/static/_content/8-plus-1.png"/>
          <h1 class="abs fg-semiBdIt 8-no" style="top:536px;left:349px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 8400, "comma": true }' ></h1>
          <h1 class="abs fg-semiBdIt 8-no" style="top:589px;left:349px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 30000, "comma": true }' ></h1>
          <h1 class="abs fg-semiBdIt 8-no" style="top:699px;left:349px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 8 }' ></h1>
        </div> 

        <!-- tab-3 pop-3 -->

        <img class="abs halfScaleC pointer 8-tab" style="top:299px;left:22px" onclick="showEightPopThree()" src="/season2025/static/_content/8-tab-3.png" />
        <div id="8-pop-3" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 8-pop-3" style="top:11px;left:11px;" src="/season2025/static/_content/8-pop-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:33px;left:1193px;width:37px;height:37px;" onclick="hideOverlay('8-pop-3')"></div>
        </div>


        <!-- tab-4 pop-4 -->

        <img class="abs halfScaleC pointer 8-tab" style="top:299px;left:515px" onclick="showEightPopFour()" src="/season2025/static/_content/8-tab-4.png" />
        <div id="8-pop-4" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 8-pop-4" style="top:11px;left:11px;" src="/season2025/static/_content/8-pop-4.png"/>
          <div class="abs contentLinkNone pointer" style="top:33px;left:1193px;width:37px;height:37px;" onclick="hideOverlay('8-pop-4')"></div>

          <!-- animations -->

          <h1 class="abs fg-semiBdIt 8-no" style="top:540px;left:344px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 150 }' ></h1>
          <h1 class="abs fg-semiBdIt 8-no" style="top:635px;left:342px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 200 }' ></h1>
          <img class="abs halfScaleC 8-plus" style="top:640px;left:407px;" src="/season2025/static/_content/8-plus-1.png"/>
          <img class="abs halfScale 8-number" style="top:725px;left:345px;" src="/season2025/static/_content/8-number-1.png"/>
        </div>


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim.fromTo(cOf("8-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1)
        }

        function showEightPopOne() {
          showOverlay('8-pop-1');
          pg8Anim = new TimelineMax();
          pg8Anim.fromTo(cOf("8-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[0])}}, 1)
          .fromTo(cOf("8-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[1])}}, 1)
          .fromTo(cOf("8-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[2])}}, 1)
          .fromTo(cOf("8-plus"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2);
        }
      
        function closeEightPopOne(){
          hideOverlay('8-pop-1')
          resetNumbers("8-no");
        }

        function showEightPopTwo() {
          showOverlay('8-pop-2')
          pg8Anim = new TimelineMax();
          pg8Anim.fromTo(cOf("8-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[3])}}, 1)
          .fromTo(cOf("8-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[4])}}, 1)
          .fromTo(cOf("8-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[5])}}, 1)
          .fromTo(cOf("8-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[6])}}, 1)
          .fromTo(cOf("8-plus"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2);
        }
      
        function closeEightPopTwo(){
          hideOverlay('8-pop-2')
          resetNumbers("8-no");
        }

        function showEightPopThree() {
          showOverlay('8-pop-3')
        }
      
        function closeEightPopThree(){
          hideOverlay('8-pop-3')
          resetNumbers("8-no");
        }

        function showEightPopFour() {
          showOverlay('8-pop-4')
          pg8Anim = new TimelineMax();
          pg8Anim.fromTo(cOf("8-no")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[7])}}, 1)
          .fromTo(cOf("8-no")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[8])}}, 1)
          .fromTo(cOf("8-number"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
          .fromTo(cOf("8-plus"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2);
        }
      
        function closeEightPopFour(){
          hideOverlay('8-pop-4')
          resetNumbers("8-no");
        }

        function onPageLeave() {
          pg8Anim.stop();
          closeEightPopOne();
          closeEightPopTwo();
          closeEightPopThree();
          closeEightPopFour();
          removeContentLinks();
        }
      `,
      "searchText": "Environment"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 9-title" style="top:49px;left:50px" src="/season2025/static/_content/9-title-1.png" />


        <!-- tab-1 pop-1 -->

        <img class="abs halfScaleC halfpulse animatedpulse pointer 9-click" style="top:144px;left:811px" onclick="showNinePopOne()" src="/season2025/static/_content/9-click-1.png" />
        <div id="9-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 9-pop-1" style="top:180px;left:366px;" src="/season2025/static/_content/9-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:210px;left:1166px;width:37px;height:37px;" onclick="hideOverlay('9-pop-1')"></div>

          <!-- animations -->

          <img class="abs halfScaleC 9-pop-title" style="top:196px;left:226px;" src="/season2025/static/_content/9-pop-title.png"/>

          <img class="abs halfScaleC 9-pop-box" style="top:220px;left:540px;" src="/season2025/static/_content/9-pop-box-1.png"/>
          <img class="abs halfScaleC 9-pop-box" style="top:368px;left:290px;" src="/season2025/static/_content/9-pop-box-2.png"/>
          <img class="abs halfScaleC 9-pop-box" style="top:450px;left:792px;" src="/season2025/static/_content/9-pop-box-3.png"/>

          <img class="abs halfScaleC 9-pop-text" style="top:257px;left:660px;" src="/season2025/static/_content/9-pop-text-1.png"/>
          <h1 class="abs fg-semiBdIt 9-no" style="top:354px;left:767px; font-size: 1.2em; color: #000000; padding: 0px; margin: 0px;"  data-number='{"to": 442 }' ></h1>
          <img class="abs halfScaleC 9-pop-text" style="top:347px;left:364px;" src="/season2025/static/_content/9-pop-text-2.png"/>
          <h1 class="abs fg-semiBdIt 9-no" style="top:450px;left:518px; font-size: 1.2em; color: #000000; padding: 0px; margin: 0px;"  data-number='{"to": 427 }' ></h1>
          <img class="abs halfScaleC 9-pop-text" style="top:401px;left:891px;" src="/season2025/static/_content/9-pop-text-3.png"/>
          <h1 class="abs fg-semiBdIt 9-no" style="top:503px;left:1039px; font-size: 1.2em; color: #000000; padding: 0px; margin: 0px;"  data-number='{"to": 417 }' ></h1>
        </div>


      <div class="contentLinkNone" onclick="Publish.goToPage(3);" style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>

      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
          pg9Anim.fromTo(cOf("9-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1)
        }

        function showNinePopOne() {
          showOverlay('9-pop-1');
          pg9Anim = new TimelineMax();
          pg9Anim.fromTo(cOf("9-pop-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1)
          .staggerFromTo(cOf("9-pop-box"), 0.5, {opacity:0, y:60}, {opacity:1, y:0}, 0.2, 1.2)
          .staggerFromTo(cOf("9-pop-text"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.4)
          .fromTo(cOf("9-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[0])}}, 1.7)
          .fromTo(cOf("9-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[1])}}, 1.8)
          .fromTo(cOf("9-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[2])}}, 1.9);
        }
      
        function closeNinePopOne(){
          hideOverlay('9-pop-1')
          resetNumbers("9-no");
        }

        function onPageLeave() {
          pg9Anim.stop();
          removeContentLinks();
          closeNinePopOne();
          resetNumbers("9-no");
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 10-title" style="top:544px;left:18px" src="/season2025/static/_content/10-title-1.png" />
        <img class="halfScale 10-title" style="top:672px;left:625px" src="/season2025/static/_content/10-title-2.png" />

        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim.staggerFromTo(cOf("10-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1)
        }

        function onPageLeave() {
          pg10Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 11-title" style="top:49px;left:50px" src="/season2025/static/_content/11-title-1.png" />

        <!-- tab-1 pop-1 -->

        <img class="abs halfScaleC halfpulse animatedpulse pointer 11-click" style="top:746px;left:673px" onclick="showElevenPopOne()" src="/season2025/static/_content/11-click-1.png" />
        <div id="11-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 11-pop-1" style="top:304px;left:382px;" src="/season2025/static/_content/11-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:696px;left:681px;width:37px;height:37px;" onclick="hideOverlay('11-pop-1')"></div>
        </div>


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim.fromTo(cOf("11-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1)
        }

        function showElevenPopOne() {
          showOverlay('11-pop-1');
        }
      
        function closeElevenPopOne(){
          hideOverlay('11-pop-1')
        }

        function onPageLeave() {
          pg11Anim.stop();
          closeElevenPopOne();
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 12-title" style="top:49px;left:50px" src="/season2025/static/_content/12-title-1.png" />

        <!-- tab-1 pop-1 -->

        <img class="abs halfScaleC halfpulse animatedpulse pointer 12-click" style="top:651px;left:168px" onclick="showTwelvePopOne()" src="/season2025/static/_content/12-click-1.png" />
        <div id="12-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 12-pop-1" style="top:12px;left:12px;" src="/season2025/static/_content/12-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:32px;left:1194px;width:37px;height:37px;" onclick="hideOverlay('12-pop-1')"></div>

          <!-- animations -->

          <h1 class="abs fg-semiBdIt 12-no" style="top:646px;left:1010px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 18 }' ></h1>
          <h1 class="abs fg-semiBdIt 12-no" style="top:731px;left:1010px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 54 }' ></h1>
        </div>


        <!-- tab-2 pop-2 -->

        <img class="abs halfScaleC halfpulse animatedpulse pointer 12-click" style="top:722px;left:168px" onclick="showTwelvePopTwo()" src="/season2025/static/_content/12-click-2.png" />
        <div id="12-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 12-pop-2" style="top:121px;left:47px;" src="/season2025/static/_content/12-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:751px;left:1155px;width:37px;height:37px;" onclick="hideOverlay('12-pop-2')"></div>
        </div>



        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim.fromTo(cOf("12-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1)
        }

        function showTwelvePopOne() {
          showOverlay('12-pop-1');
          pg12Anim = new TimelineMax();
          pg12Anim.fromTo(cOf("12-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no")[0])}}, 1)
          .fromTo(cOf("12-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("12-no")[1])}}, 1)
        }
      
        function closeTwelvePopOne(){
          hideOverlay('12-pop-1')
          resetNumbers("12-no");
        }

        function showTwelvePopTwo() {
          showOverlay('12-pop-2');
        }
      
        function closeTwelvePopTwo(){
          hideOverlay('12-pop-2')
        }

        function onPageLeave() {
          pg12Anim.stop();
          resetNumbers("12-no");
          closeTwelvePopOne();
          closeTwelvePopTwo();
          removeContentLinks();
        }
      `,
      "searchText": "Social"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 13-title" style="top:49px;left:50px" src="/season2025/static/_content/13-title-1.png" />
        <img class="halfScaleC 13-arrow" style="top:523px;left:30px" src="/season2025/static/_content/13-arrow-1.png" />


        <!-- tab-1 pop-1 -->

        <img class="abs halfScaleC 13-tab" style="top:35px;left:-27px" onclick="showThirteenPopOne()" src="/season2025/static/_content/13-tab-1.png" />
        <img class="abs halfScaleC halfpulse animatedpulse pointer 13-click" style="top:179px;left:737px" onclick="showThirteenPopOne()" src="/season2025/static/_content/13-click-1.png" />
        <div id="13-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 13-pop-1" style="top:185px;left:386px;" src="/season2025/static/_content/13-pop-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:200px;left:1165px;width:37px;height:37px;" onclick="hideOverlay('13-pop-1')"></div>
        </div>


        <!-- tab-2 pop-2 -->

        <img class="abs halfScaleC 13-tab" style="top:350px;left:-27px" onclick="showThirteenPopTwo()" src="/season2025/static/_content/13-tab-2.png" />
        <img class="abs halfScaleC halfpulse animatedpulse pointer 13-click" style="top:495px;left:1023px" onclick="showThirteenPopTwo()" src="/season2025/static/_content/13-click-1.png" />
        <div id="13-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 13-pop-2" style="top:185px;left:386px;" src="/season2025/static/_content/13-pop-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:200px;left:1165px;width:37px;height:37px;" onclick="hideOverlay('13-pop-2')"></div>
        </div>

        <!-- tab-3 pop-3 -->

        <img class="abs halfScale halfpulse animatedpulse pointer 13-tab" style="top:730px;left:33px" onclick="showThirteenPopThree()" src="/season2025/static/_content/13-tab-3.png" />
        <div id="13-pop-3" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 13-pop-3" style="top:12px;left:12px;" src="/season2025/static/_content/13-pop-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:33px;left:1195px;width:37px;height:37px;" onclick="hideOverlay('13-pop-3')"></div>
        </div>


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>

      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();
          pg13Anim.fromTo(cOf("13-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1)
        }

        function showThirteenPopOne() {
          showOverlay('13-pop-1');
        }

        function closeThirteenPopOne(){
          hideOverlay('13-pop-1');
        }

        function showThirteenPopTwo() {
          showOverlay('13-pop-2');
        }

        function closeThirteenPopTwo(){
          hideOverlay('13-pop-2');
        }

        function showThirteenPopThree() {
          showOverlay('13-pop-3');
        }

        function closeThirteenPopThree(){
          hideOverlay('13-pop-3');
        }

        function onPageLeave() {
          pg13Anim.stop();
          closeThirteenPopOne();
          closeThirteenPopTwo();
          closeThirteenPopThree();
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 14-title" style="top:544px;left:18px" src="/season2025/static/_content/14-title-1.png" />
        <img class="halfScale 14-title" style="top:663px;left:625px" src="/season2025/static/_content/14-title-2.png" />
      
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
          pg14Anim.staggerFromTo(cOf("14-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1)
        }

        function onPageLeave() {
          pg14Anim.stop();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 15-title" style="top:50px;left:47px" src="/season2025/static/_content/15-title-1.png" />


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>

      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim.staggerFromTo(cOf("15-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1)
        }

        function onPageLeave() {
          pg15Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 16-title" style="top:50px;left:56px" src="/season2025/static/_content/16-title-1.png" />
        <img class="halfScaleC 16-arrow" style="top:630px;left:30px" src="/season2025/static/_content/16-arrow-1.png" />


        <!-- tab-1 pop-1 -->

        <img class="abs halfScaleC pointer 16-tab" style="top:-33px;left:240px" onclick="showSixteenPopOne()" src="/season2025/static/_content/16-tab-1.png" />
        <div id="16-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 16-pop-1" style="top:123px;left:346px;" src="/season2025/static/_content/16-pop-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:145px;left:1159px;width:37px;height:37px;" onclick="hideOverlay('16-pop-1')"></div>
        </div>


        <!-- tab-2 pop-2 -->

        <img class="abs halfScaleC pointer 16-tab" style="top:-33px;left:459px" onclick="showSixteenPopTwo()" src="/season2025/static/_content/16-tab-2.png" />
        <div id="16-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 16-pop-2" style="top:123px;left:346px;" src="/season2025/static/_content/16-pop-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:145px;left:1159px;width:37px;height:37px;" onclick="hideOverlay('16-pop-2')"></div>
        </div>


        <!-- tab-3 pop-3 -->

        <img class="abs halfScaleC pointer 16-tab" style="top:-33px;left:678px" onclick="showSixteenPopThree()" src="/season2025/static/_content/16-tab-3.png" />
        <div id="16-pop-3" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 16-pop-3" style="top:123px;left:346px;" src="/season2025/static/_content/16-pop-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:145px;left:1159px;width:37px;height:37px;" onclick="hideOverlay('16-pop-3')"></div>
        </div>
      

        <!-- tab-4 pop-4 -->

        <img class="abs halfScaleC pointer 16-tab" style="top:-33px;left:896px" onclick="showSixteenPopFour()" src="/season2025/static/_content/16-tab-4.png" />
        <div id="16-pop-4" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 16-pop-4" style="top:123px;left:346px;" src="/season2025/static/_content/16-pop-4.png"/>
          <div class="abs contentLinkNone pointer" style="top:145px;left:1159px;width:37px;height:37px;" onclick="hideOverlay('16-pop-4')"></div>
        </div>


        <!-- tab-5 pop-5 -->

        <img class="abs halfScaleC pointer 16-tab" style="top:286px;left:240px" onclick="showSixteenPopFive()" src="/season2025/static/_content/16-tab-5.png" />
        <div id="16-pop-5" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 16-pop-5" style="top:123px;left:346px;" src="/season2025/static/_content/16-pop-5.png"/>
          <div class="abs contentLinkNone pointer" style="top:145px;left:1159px;width:37px;height:37px;" onclick="hideOverlay('16-pop-5')"></div>
        </div>


        <!-- tab-6 pop-6 -->

        <img class="abs halfScaleC pointer 16-tab" style="top:286px;left:458px" onclick="showSixteenPopSix()" src="/season2025/static/_content/16-tab-6.png" />
        <div id="16-pop-6" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 16-pop-6" style="top:123px;left:346px;" src="/season2025/static/_content/16-pop-6.png"/>
          <div class="abs contentLinkNone pointer" style="top:145px;left:1159px;width:37px;height:37px;" onclick="hideOverlay('16-pop-6')"></div>
        </div>


        <!-- tab-7 pop-7 -->

        <img class="abs halfScaleC pointer 16-tab" style="top:286px;left:677px" onclick="showSixteenPopSeven()" src="/season2025/static/_content/16-tab-7.png" />
        <div id="16-pop-7" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 16-pop-7" style="top:123px;left:346px;" src="/season2025/static/_content/16-pop-7.png"/>
          <div class="abs contentLinkNone pointer" style="top:145px;left:1159px;width:37px;height:37px;" onclick="hideOverlay('16-pop-7')"></div>
        </div>


        <!-- tab-8 pop-8 -->

        <img class="abs halfScaleC pointer 16-tab" style="top:286px;left:895px" onclick="showSixteenPopEight()" src="/season2025/static/_content/16-tab-8.png" />
        <div id="16-pop-8" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 16-pop-8" style="top:123px;left:346px;" src="/season2025/static/_content/16-pop-8.png"/>
          <div class="abs contentLinkNone pointer" style="top:145px;left:1159px;width:37px;height:37px;" onclick="hideOverlay('16-pop-8')"></div>
        </div>


        <!-- tab-9 link -->

        <a href="https://sailgp.com/general/purpose/better-planet/local-impact-projects?tab=dmDOsTQoFsJA9JA1Bp2K2" target="_blank" style="top:314px; left:305px; width:298px; height:14px;">
          <img class="halfScaleC pointer 16-tab" style="top:743px;left:-87px" src="/season2025/static/_content/16-tab-9.png" />
        </a> 


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>

      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim.staggerFromTo(cOf("16-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1)
        }

        function showSixteenPopOne() {
          showOverlay('16-pop-1');
        }

        function closeSixteenPopOne(){
          hideOverlay('16-pop-1');
        }

        function showSixteenPopTwo() {
          showOverlay('16-pop-2');
        }

        function closeSixteenPopTwo(){
          hideOverlay('16-pop-2');
        }

        function showSixteenPopThree() {
          showOverlay('16-pop-3');
        }

        function closeSixteenPopThree(){
          hideOverlay('16-pop-3');
        }

        function showSixteenPopFour() {
          showOverlay('16-pop-4');
        }

        function closeSixteenPopFour(){
          hideOverlay('16-pop-4');
        }

        function showSixteenPopFive() {
          showOverlay('16-pop-5');
        }

        function closeSixteenPopFive(){
          hideOverlay('16-pop-5');
        }

        function showSixteenPopSix() {
          showOverlay('16-pop-6');
        }

        function closeSixteenPopSix(){
          hideOverlay('16-pop-6');
        }

        function showSixteenPopSeven() {
          showOverlay('16-pop-7');
        }

        function closeSixteenPopSeven(){
          hideOverlay('16-pop-7');
        }

          function showSixteenPopEight() {
          showOverlay('16-pop-8');
        }

        function closeSixteenPopEight(){
          hideOverlay('16-pop-8');
        }

        function onPageLeave() {
          pg16Anim.stop();
          closeSixteenPopOne();
          closeSixteenPopTwo();
          closeSixteenPopThree();
          closeSixteenPopFour();
          closeSixteenPopFive();
          closeSixteenPopSix();
          closeSixteenPopSeven();
          closeSixteenPopEight();
          removeContentLinks();
        }
      `,
      "searchText": "Governance"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 17-title" style="top:50px;left:49px" src="/season2025/static/_content/17-title-1.png" />
        <img class="halfScaleC 17-arrow" style="top:91px;left:31px" src="/season2025/static/_content/17-arrow-1.png" />


        <!-- image-1 pop-1 -->

        <img class="abs halfScaleC pointer 17-img" style="top:-112px;left:-139px" onclick="showSeventeenPopOne()" src="/season2025/static/_content/17-img-1.png" />
        <div id="17-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 17-pop-1" style="top:12px;left:12px;" src="/season2025/static/_content/17-pop-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:32px;left:1194px;width:37px;height:37px;" onclick="hideOverlay('17-pop-1')"></div>

          <!-- animations -->

          <h1 class="abs fg-semiBdIt 17-no" style="top:290px;left:1014px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;" data-number='{"to": 100}' ></h1>
          <img class="abs halfScaleC 17-percentage" style="top:290px;left:1066px;" src="/season2025/static/_content/17-perc-1.png"/>
          <h1 class="abs fg-semiBdIt 17-no" style="top:375px;left:1014px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;" data-number='{"to": 99.9, "decimals" : 1}' ></h1>
          <img class="abs halfScaleC 17-percentage" style="top:374px;left:1080px;" src="/season2025/static/_content/17-perc-1.png"/>
          <h1 class="abs fg-semiBdIt 17-no" style="top:530px;left:1014px; font-size: 2.7em; color: #ffffff; padding: 0px; margin: 0px;" data-number='{"to": 0.30, "decimals": 2 }' ></h1>
          <img class="abs halfScaleC 17-pop-1-numb" style="top:598px;left:945px;" src="/season2025/static/_content/17-pop-1-number.png"/>

          <!-- pop-1-clicks -->

          <img class="abs halfScaleC halfpulse animatedpulse pointer 17-click" style="top:703px;left:267px" onclick="openSeventeenPopOneOne('17-energy', '17-energy-1')" src="/season2025/static/_content/17-click-1.png" />

          <img class="abs halfScaleC halfpulse animatedpulse pointer 17-click" style="top:708px;left:530px" onclick="openTab('17-energy', '17-energy-2')" src="/season2025/static/_content/17-click-1.png" />
          
          <div id="17-energy-1" class="17-energy hidden noclick">
            <img class="abs halfScale 17-pop-1-tab-1" style="top:459px;left:50px;" src="/season2025/static/_content/17-pop-1-tab-1.png"/>
            <div class="abs contentLinkNone pointer" style="top:455px;left:695px;width:41px;height:42px;" onclick="closeTab('17-energy', '17-energy-1')"></div>

            <!-- animations -->

            <img class="abs halfScale 17-tab-1-title" style="top:520px;left:68px;" src="/season2025/static/_content/17-tab-1-title.png"/>

            <img class="abs halfScale 17-tab-1-text" style="top:563px;left:67px;" src="/season2025/static/_content/17-tab-1-text-1.png"/>
            <img class="abs halfScale 17-tab-1-text" style="top:608px;left:67px;" src="/season2025/static/_content/17-tab-1-text-2.png"/>
            <img class="abs halfScale 17-tab-1-text" style="top:653px;left:67px;" src="/season2025/static/_content/17-tab-1-text-3.png"/>
            <img class="abs halfScale 17-tab-1-text" style="top:698px;left:67px;" src="/season2025/static/_content/17-tab-1-text-4.png"/>
            <img class="abs halfScale 17-tab-1-text" style="top:743px;left:67px;" src="/season2025/static/_content/17-tab-1-text-5.png"/>

            <img class="abs halfScale 17-dot-first" style="top:561px;left:224px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-first" style="top:561px;left:244px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-first" style="top:561px;left:265px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-first" style="top:561px;left:286px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-first" style="top:561px;left:307px;" src="/season2025/static/_content/17-dot-1.png"/>

            <img class="abs halfScale 17-dot-second" style="top:586px;left:224px;" src="/season2025/static/_content/17-tab-1-icon.png"/>
            <img class="abs halfScale 17-dot-second" style="top:606px;left:245px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-second" style="top:606px;left:265px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-second" style="top:606px;left:285px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-second" style="top:606px;left:307px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-second" style="top:606px;left:327px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-second" style="top:606px;left:348px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-second" style="top:606px;left:369px;" src="/season2025/static/_content/17-dot-1.png"/>

            <img class="abs halfScale 17-dot-third" style="top:651px;left:225px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-third" style="top:651px;left:246px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-third" style="top:651px;left:266px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-third" style="top:651px;left:287px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-third" style="top:631px;left:307px;" src="/season2025/static/_content/17-tab-1-icon.png"/>
            <img class="abs halfScale 17-dot-third" style="top:651px;left:328px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-third" style="top:651px;left:349px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-third" style="top:651px;left:369px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-third" style="top:651px;left:390px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-third" style="top:651px;left:411px;" src="/season2025/static/_content/17-dot-1.png"/>

            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:225px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:246px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:266px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:287px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:307px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:328px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:349px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:369px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:390px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:676px;left:410px;" src="/season2025/static/_content/17-tab-1-icon.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:431px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:452px;" src="/season2025/static/_content/17-dot-1.png"/>
            <img class="abs halfScale 17-dot-fourth" style="top:696px;left:473px;" src="/season2025/static/_content/17-dot-1.png"/>

            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:225px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:246px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:266px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:286px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:307px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:328px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:349px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:369px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:390px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:410px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:741px;left:431px;" src="/season2025/static/_content/17-filled-dot-1.png"/>
            <img class="abs halfScale 17-dot-fifth" style="top:720px;left:452px;" src="/season2025/static/_content/17-tab-1-icon.png"/>

            <img class="abs halfScale 17-numb" style="top:578px;left:528px;" src="/season2025/static/_content/17-number-1.png"/>
          </div>

          <div id="17-energy-2" class="17-energy hidden noclick">
            <img class="abs halfScale 17-pop-1-tab-2" style="top:297px;left:342px;" src="/season2025/static/_content/17-pop-1-tab-2.png"/>
            <div class="abs contentLinkNone pointer" style="top:295px;left:553px;width:41px;height:42px;" onclick="closeTab('17-energy', '17-energy-2')"></div>
          </div>

          <img class="abs halfScaleC halfpulse animatedpulse pointer 17-click" style="top:708px;left:794px" onclick="openTab('17-energy', '17-energy-3')" src="/season2025/static/_content/17-click-1.png" />
          <div id="17-energy-3" class="17-energy hidden noclick">
            <img class="abs halfScale 17-pop-1-tab-3" style="top:297px;left:609px;" src="/season2025/static/_content/17-pop-1-tab-3.png"/>
            <div class="abs contentLinkNone pointer" style="top:295px;left:821px;width:41px;height:42px;" onclick="closeTab('17-energy', '17-energy-3')"></div>
          </div>

          <img class="abs halfScaleC halfpulse animatedpulse pointer 17-click" style="top:708px;left:1124px" onclick="openTab('17-energy', '17-energy-4')" src="/season2025/static/_content/17-click-1.png" />
          <div id="17-energy-4" class="17-energy hidden noclick">
            <img class="abs halfScale 17-pop-1-tab-4" style="top:297px;left:907px;" src="/season2025/static/_content/17-pop-1-tab-4.png"/>
            <div class="abs contentLinkNone pointer" style="top:313px;left:1151px;width:41px;height:42px;" onclick="closeTab('17-energy', '17-energy-4')"></div>
          </div>    
        </div>


        <!-- image-2 pop-2 -->

        <img class="abs halfScaleC pointer 17-img" style="top:-112px;left:252px" onclick="showSeventeenPopTwo()" src="/season2025/static/_content/17-img-2.png" />
        <div id="17-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 17-pop-2" style="top:12px;left:12px;" src="/season2025/static/_content/17-pop-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:32px;left:1194px;width:37px;height:37px;" onclick="hideOverlay('17-pop-2')"></div>

          <!-- pop-2-click -->

          <img class="abs halfScaleC halfpulse animatedpulse pointer 17-click" style="top:711px;left:1144px" onclick="openPop('17-tab-2')" src="/season2025/static/_content/17-click-2.png" />
          <div id="17-tab-2" class="hidden noclick">
            <img class="abs halfScale 17-tab-1-pop-2" style="top:179px;left:50px;" src="/season2025/static/_content/17-tab-1-pop-2.png"/>
            <div class="abs contentLinkNone pointer" style="top:183px;left:1175px;width:41px;height:42px;" onclick="closePop('17-tab-2')"></div>
          </div>
        </div>


        <!-- image-3 pop-3 -->

        <img class="abs halfScaleC pointer 17-img" style="top:-112px;left:644px" onclick="showSeventeenPopThree()" src="/season2025/static/_content/17-img-3.png" />
        <div id="17-pop-3" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 17-pop-3" style="top:12px;left:12px;" src="/season2025/static/_content/17-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:32px;left:1194px;width:37px;height:37px;" onclick="hideOverlay('17-pop-3')"></div>
      </div>


      <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
          pg17Anim.staggerFromTo(cOf("17-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1)
        }

        function showSeventeenPopOne() {
          showOverlay('17-pop-1');
          pg17Anim = new TimelineMax();
          pg17Anim.fromTo(cOf("17-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[0])}}, 1)
          .fromTo(cOf("17-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[1])}}, 1)
          .fromTo(cOf("17-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[2])}}, 1)
          .staggerFromTo(cOf("17-percentage"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2)
          .fromTo(cOf("17-pop-1-numb"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1.2);
        }

        function closeSeventeenPopOne(){
          hideOverlay('17-pop-1')
          closeTab('17-energy', '17-energy-1')
          closeTab('17-energy', '17-energy-2')
          closeTab('17-energy', '17-energy-3')
          closeTab('17-energy', '17-energy-4')
        }

        function openSeventeenPopOneOne(klass, id){
          openTab(klass, id)
          pg17PopOneOneAnim = new TimelineMax();
          pg17PopOneOneAnim.fromTo(cOf("17-tab-1-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.8)
          .staggerFromTo(cOf("17-tab-1-text"), 0.5, {opacity:0, y:30}, {opacity:1, y:0}, 0.1, 1.1)
          .fromTo(cOf("17-dot-first"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.15)
          .fromTo(cOf("17-dot-second"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.25)
          .fromTo(cOf("17-dot-third"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.35)
          .fromTo(cOf("17-dot-fourth"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.45)
          .fromTo(cOf("17-dot-fifth"), 0.4, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.55)
          .fromTo(cOf("17-numb"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1.6);
        }

        function showSeventeenPopTwo() {
          showOverlay('17-pop-2');
        }

        function closeSeventeenPopTwo(){
          closePop('17-tab-2');  
          hideOverlay('17-pop-2');  
        }

        function showSeventeenPopThree() {
          showOverlay('17-pop-3');
        }

        function closeSeventeenPopThree(){
          hideOverlay('17-pop-3');
        }

        function onPageLeave() {
          pg17Anim.stop();
          resetNumbers("17-no");
          closeSeventeenPopOne();
          closeSeventeenPopTwo();
          hideOverlay('17-pop-3');
          closeTab('17-energy-1');
          closeTab('17-energy-2');
          closeTab('17-energy-3');
          closeTab('17-energy-4');
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 18-title" style="top:50px;left:51px" src="/season2025/static/_content/18-title-1.png" />
        <img class="halfScaleC 18-arrow" style="top:91px;left:31px" src="/season2025/static/_content/18-arrow-1.png" />


        <!-- Image pop-1 -->

        <img class="abs halfScaleC pointer 18-img" style="top:38px;left:-236px" onclick="showEighteenPopOne()" src="/season2025/static/_content/18-tab-1.png" />
        <div id="18-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 18-pop-1" style="top:12px;left:12px;" src="/season2025/static/_content/18-pop-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:32px;left:1194px;width:37px;height:37px;" onclick="hideOverlay('18-pop-1')"></div>
        </div>


        <!-- Image pop-2 -->

        <img class="abs halfScaleC pointer 18-img" style="top:38px;left:355px" onclick="showEighteenPopTwo()" src="/season2025/static/_content/18-tab-2.png" />
        <div id="18-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 18-pop-2" style="top:12px;left:12px;" src="/season2025/static/_content/18-pop-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:32px;left:1194px;width:37px;height:37px;" onclick="hideOverlay('18-pop-2')"></div>

          <!-- animations -->

          <h1 class="abs fg-semiBdIt 18-no" style="top:492px;left:76px; font-size: 3.9em; color: #ffffff; padding: 0px; margin: 0px;" data-number='{"to": 50}' ></h1>
          <img class="abs halfScaleC 18-percentage" style="top:489px;left:126px;" src="/season2025/static/_content/18-perc-1.png"/>
          <h1 class="abs fg-semiBdIt 18-no" style="top:657px;left:76px; font-size: 3.9em; color: #ffffff; padding: 0px; margin: 0px;" data-number='{"to": 2040}' ></h1>
        </div>


        <!-- Image pop-3 -->

        <img class="abs halfScaleC pointer 18-img" style="top:358px;left:-236px" onclick="showEighteenPopThree()" src="/season2025/static/_content/18-tab-3.png" />
        <div id="18-pop-3" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 18-pop-3" style="top:12px;left:12px;" src="/season2025/static/_content/18-pop-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:32px;left:1194px;width:37px;height:37px;" onclick="hideOverlay('18-pop-3')"></div>
  
          <!-- tab link -->

          <a href="https://purpose-impact.sailgp.com/season4/17-1" target="_blank style="top:314px; left:305px; width:298px; height:14px;">
            <img class="abs halfScaleC halfpulse animatedpulse pointer 18-click" style="top:291px;left:236px" src="/season2025/static/_content/18-click-1.png" />
          </a>
        </div>


        <!-- Image pop-4 -->

        <img class="abs halfScaleC pointer 18-img" style="top:358px;left:355px" onclick="showEighteenPopFour()" src="/season2025/static/_content/18-tab-4.png" />
        <div id="18-pop-4" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 18-pop-4" style="top:12px;left:12px;" src="/season2025/static/_content/18-pop-4.png"/>
          <div class="abs contentLinkNone pointer" style="top:32px;left:1194px;width:37px;height:37px;" onclick="hideOverlay('18-pop-4')"></div>
        </div>


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();
          pg18Anim.staggerFromTo(cOf("18-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1);
        }

        function showEighteenPopOne() {
          showOverlay('18-pop-1');
        }

        function closeEighteenPopOne(){
          hideOverlay('18-pop-1');
        }

         function showEighteenPopTwo() {
          showOverlay('18-pop-2');
          pg18Anim = new TimelineMax();
          pg18Anim.fromTo(cOf("18-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("18-no")[0])}}, 1)
          .fromTo(cOf("18-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("18-no")[1])}}, 1.1)
          .fromTo(cOf("18-percentage"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.9);
        }

        function closeEighteenPopTwo(){
          hideOverlay('18-pop-2');
        }

        function showEighteenPopThree() {
          showOverlay('18-pop-3');
        }

        function closeEighteenPopThree(){
          hideOverlay('18-pop-3');
        }

        function showEighteenPopFour() {
          showOverlay('18-pop-4');
        }

        function closeEighteenPopFour(){
          hideOverlay('18-pop-4');
        }

        function onPageLeave() {
          pg18Anim.stop();
          resetNumbers("18-no");
          closeEighteenPopOne();
          closeEighteenPopTwo();
          closeEighteenPopThree();
          closeEighteenPopFour();
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 19-title" style="top:50px;left:53px" src="/season2025/static/_content/19-title-1.png" />

        <!-- clicks -->

        <img class="abs halfScaleC halfpulse animatedpulse pointer 19-click" style="top:129px;left:544px" onclick="openTab('19-carbonfootprint', '19-carbonfootprint-1')" src="/season2025/static/_content/19-click-1.png" />
        <img class="abs halfScaleC halfpulse animatedpulse pointer 19-click" style="top:579px;left:513px" onclick="openTab('19-carbonfootprint', '19-carbonfootprint-2')" src="/season2025/static/_content/19-click-2.png" />
        <img class="abs halfScaleC halfpulse animatedpulse pointer 19-click" style="top:708px;left:241px" onclick="openTab('19-carbonfootprint', '19-carbonfootprint-3')" src="/season2025/static/_content/19-click-2.png" />
        <img class="abs halfScaleC halfpulse animatedpulse pointer 19-click" style="top:708px;left:550px" onclick="openTab('19-carbonfootprint', '19-carbonfootprint-4')" src="/season2025/static/_content/19-click-2.png" />


        <!-- pop-1 -->

        <div id="19-carbonfootprint-1" class="hidden noclick">
          <img class="abs halfScale 19-pop-1" style="top:109px;left:50px;" src="/season2025/static/_content/19-pop-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:120px;left:1173px;width:41px;height:42px;" onclick="closeTab('19-carbonfootprint', '19-carbonfootprint-1')"></div>
        </div>


        <!-- pop-2 -->

        <div id="19-carbonfootprint-2" class="hidden noclick">
          <img class="abs halfScale 19-pop-2" style="top:45px;left:50px;" src="/season2025/static/_content/19-pop-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:749px;left:863px;width:41px;height:42px;" onclick="closeTab('19-carbonfootprint', '19-carbonfootprint-2')"></div>
        </div>


        <!-- pop-3 -->

        <div id="19-carbonfootprint-3" class="hidden noclick">
          <img class="abs halfScale 19-pop-3" style="top:0px;left:50px;" src="/season2025/static/_content/19-pop-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:742px;left:605px;width:41px;height:42px;" onclick="closeTab('19-carbonfootprint', '19-carbonfootprint-3')"></div>
        </div>


        <!-- pop-4 -->

        <div id="19-carbonfootprint-4" class="hidden noclick">
          <img class="abs halfScale 19-pop-4" style="top:123px;left:621px;" src="/season2025/static/_content/19-pop-4.png"/>
          <div class="abs contentLinkNone pointer" style="top:767px;left:962px;width:41px;height:42px;" onclick="closeTab('19-carbonfootprint', '19-carbonfootprint-4')"></div>
        </div>


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg19Anim = new TimelineMax();
          pg19Anim.staggerFromTo(cOf("19-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1);
        }

        function onPageLeave() {
          pg19Anim.stop();
          closeTab('19-carbonfootprint','19-carbonfootprint-1');
          closeTab('19-carbonfootprint','19-carbonfootprint-2');
          closeTab('19-carbonfootprint','19-carbonfootprint-3');
          closeTab('19-carbonfootprint','19-carbonfootprint-4');
          removeContentLinks();
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 20-title" style="top:50px;left:47px" src="/season2025/static/_content/20-title-1.png" />

        
        <!-- click pop-1 -->

        <img class="abs halfScaleC halfpulse animatedpulse pointer 20-click" style="top:265px;left:62px" onclick="showTwentyPopOne()" src="/season2025/static/_content/20-click-1.png" />
        <div id="20-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 20-pop-1" style="top:186px;left:641px;" src="/season2025/static/_content/20-pop-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:763px;left:1152px;width:37px;height:37px;" onclick="hideOverlay('20-pop-1')"></div>
        </div>


        <!-- click pop-2 -->

        <img class="abs halfScaleC halfpulse animatedpulse pointer 20-click" style="top:265px;left:660px" onclick="showTwentyPopTwo()" src="/season2025/static/_content/20-click-1.png" />
        <div id="20-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 20-pop-2" style="top:186px;left:48px;" src="/season2025/static/_content/20-pop-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:763px;left:553px;width:37px;height:37px;" onclick="hideOverlay('20-pop-2')"></div>
        </div>


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
          pg20Anim.staggerFromTo(cOf("20-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1);
        }

        function showTwentyPopOne(){
          showOverlay('20-pop-1')
        }

        function closeTwentyPopOne() {
          hideOverlay('20-pop-1');
        }

        function showTwentyPopTwo(){
          showOverlay('20-pop-2')
        }

        function closeTwentyPopTwo() {
          hideOverlay('20-pop-2');
        }

        function onPageLeave() {
          pg20Anim.stop();
          closeTwentyPopOne();
          closeTwentyPopTwo();
          removeContentLinks();
        }
      `,
      "searchText": ""
      }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
        
        <img class="halfScale 21-title" style="top:50px;left:50px" src="/season2025/static/_content/21-title-1.png" />


        <!-- click main pop-1 -->

        <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:135px;left:532px" onclick="showTwentyOnePopOne()" src="/season2025/static/_content/21-tab-1.png" />
        <div id="21-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 21-pop-1" style="top:36px;left:52px;" src="/season2025/static/_content/21-pop-bg.png" />
          <div class="abs contentLinkNone pointer" style="top:751px;left:1155px;width:37px;height:37px;" onclick="hideOverlay('21-pop-1')"></div>

          <!-- main pop-1 -->

          <img class="abs halfScaleC halfpulse animatedpulse 21-click" style="top:95px;left:300px" src="/season2025/static/_content/21-click-1.png" />
          <div class="abs contentLinkNone pointer" style="top:751px;left:1155px;width:37px;height:37px;" onclick="hideOverlay('21-pop-1')"></div>


          <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:116px;left:0px" onclick="openTab('21-topic', '21-topic-1')" src="/season2025/static/_content/21-pop-1-text-1.png" />
          <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:206px;left:20px" onclick="openTab('21-topic', '21-topic-2')" src="/season2025/static/_content/21-pop-1-text-2.png" />
          <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:296px;left:18px" onclick="openTab('21-topic', '21-topic-3')" src="/season2025/static/_content/21-pop-1-text-3.png" />
          <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:366px;left:17px" onclick="openTab('21-topic', '21-topic-4')" src="/season2025/static/_content/21-pop-1-text-4.png" />
          <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:476px;left:18px" onclick="openTab('21-topic', '21-topic-5')" src="/season2025/static/_content/21-pop-1-text-5.png" />
          <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:547px;left:8px" onclick="openTab('21-topic', '21-topic-6')" src="/season2025/static/_content/21-pop-1-text-6.png" />
          <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:657px;left:56px" onclick="openTab('21-topic', '21-topic-7')" src="/season2025/static/_content/21-pop-1-text-7.png" />
          <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:748px;left:56px" onclick="openTab('21-topic', '21-topic-8')" src="/season2025/static/_content/21-pop-1-text-8.png" />


          <!-- topic-1 -->

          <div id="21-topic-1" class="21-topic hidden noclick">
            <img class="abs halfScale 21-pop-2" style="top:27px;left:50px;" src="/season2025/static/_content/21-pop-2.png"/>
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:206px;left:20px" onclick="openTab('21-topic', '21-topic-2')" src="/season2025/static/_content/21-pop-1-text-2.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:296px;left:18px" onclick="openTab('21-topic', '21-topic-3')" src="/season2025/static/_content/21-pop-1-text-3.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:366px;left:17px" onclick="openTab('21-topic', '21-topic-4')" src="/season2025/static/_content/21-pop-1-text-4.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:476px;left:18px" onclick="openTab('21-topic', '21-topic-5')" src="/season2025/static/_content/21-pop-1-text-5.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:547px;left:8px" onclick="openTab('21-topic', '21-topic-6')" src="/season2025/static/_content/21-pop-1-text-6.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:657px;left:56px" onclick="openTab('21-topic', '21-topic-7')" src="/season2025/static/_content/21-pop-1-text-7.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:748px;left:56px" onclick="openTab('21-topic', '21-topic-8')" src="/season2025/static/_content/21-pop-1-text-8.png" />
            <div class="abs contentLinkNone pointer" style="top:748px;left:1152px;width:41px;height:42px;" onclick="closeTab('21-topic', '21-topic-1')"></div>
          </div>


          <!-- topic 2 -->


          <div id="21-topic-2" class="21-topic hidden noclick">
            <img class="abs halfScale 21-pop-3" style="top:27px;left:50px;" src="/season2025/static/_content/21-pop-3.png"/>
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:116px;left:0px" onclick="openTab('21-topic', '21-topic-1')" src="/season2025/static/_content/21-pop-1-text-1.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:296px;left:18px" onclick="openTab('21-topic', '21-topic-3')" src="/season2025/static/_content/21-pop-1-text-3.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:366px;left:17px" onclick="openTab('21-topic', '21-topic-4')" src="/season2025/static/_content/21-pop-1-text-4.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:476px;left:18px" onclick="openTab('21-topic', '21-topic-5')" src="/season2025/static/_content/21-pop-1-text-5.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:547px;left:8px" onclick="openTab('21-topic', '21-topic-6')" src="/season2025/static/_content/21-pop-1-text-6.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:657px;left:56px" onclick="openTab('21-topic', '21-topic-7')" src="/season2025/static/_content/21-pop-1-text-7.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:748px;left:56px" onclick="openTab('21-topic', '21-topic-8')" src="/season2025/static/_content/21-pop-1-text-8.png" />
            <div class="abs contentLinkNone pointer" style="top:748px;left:1152px;width:41px;height:42px;" onclick="closeTab('21-topic', '21-topic-2')"></div>
          </div>


          <!-- topic 3 -->


          <div id="21-topic-3" class="21-topic hidden noclick">
            <img class="abs halfScale 21-pop-4" style="top:27px;left:50px;" src="/season2025/static/_content/21-pop-4.png"/>
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:116px;left:0px" onclick="openTab('21-topic', '21-topic-1')" src="/season2025/static/_content/21-pop-1-text-1.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:206px;left:20px" onclick="openTab('21-topic', '21-topic-2')" src="/season2025/static/_content/21-pop-1-text-2.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:366px;left:17px" onclick="openTab('21-topic', '21-topic-4')" src="/season2025/static/_content/21-pop-1-text-4.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:476px;left:18px" onclick="openTab('21-topic', '21-topic-5')" src="/season2025/static/_content/21-pop-1-text-5.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:547px;left:8px" onclick="openTab('21-topic', '21-topic-6')" src="/season2025/static/_content/21-pop-1-text-6.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:657px;left:56px" onclick="openTab('21-topic', '21-topic-7')" src="/season2025/static/_content/21-pop-1-text-7.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:748px;left:56px" onclick="openTab('21-topic', '21-topic-8')" src="/season2025/static/_content/21-pop-1-text-8.png" />
            <div class="abs contentLinkNone pointer" style="top:748px;left:1152px;width:41px;height:42px;" onclick="closeTab('21-topic', '21-topic-3')"></div>
          </div>


          <!-- topic 4 -->


          <div id="21-topic-4" class="21-topic hidden noclick">
            <img class="abs halfScale 21-pop-5" style="top:27px;left:50px;" src="/season2025/static/_content/21-pop-5.png"/>
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:116px;left:0px" onclick="openTab('21-topic', '21-topic-1')" src="/season2025/static/_content/21-pop-1-text-1.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:206px;left:20px" onclick="openTab('21-topic', '21-topic-2')" src="/season2025/static/_content/21-pop-1-text-2.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:296px;left:18px" onclick="openTab('21-topic', '21-topic-3')" src="/season2025/static/_content/21-pop-1-text-3.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:476px;left:18px" onclick="openTab('21-topic', '21-topic-5')" src="/season2025/static/_content/21-pop-1-text-5.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:547px;left:8px" onclick="openTab('21-topic', '21-topic-6')" src="/season2025/static/_content/21-pop-1-text-6.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:657px;left:56px" onclick="openTab('21-topic', '21-topic-7')" src="/season2025/static/_content/21-pop-1-text-7.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:748px;left:56px" onclick="openTab('21-topic', '21-topic-8')" src="/season2025/static/_content/21-pop-1-text-8.png" />
            <div class="abs contentLinkNone pointer" style="top:748px;left:1152px;width:41px;height:42px;" onclick="closeTab('21-topic', '21-topic-4')"></div>
          </div>


          <!-- topic 5 -->


          <div id="21-topic-5" class="21-topic hidden noclick">
            <img class="abs halfScale 21-pop-6" style="top:27px;left:50px;" src="/season2025/static/_content/21-pop-6.png"/>
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:116px;left:0px" onclick="openTab('21-topic', '21-topic-1')" src="/season2025/static/_content/21-pop-1-text-1.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:206px;left:20px" onclick="openTab('21-topic', '21-topic-2')" src="/season2025/static/_content/21-pop-1-text-2.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:296px;left:18px" onclick="openTab('21-topic', '21-topic-3')" src="/season2025/static/_content/21-pop-1-text-3.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:366px;left:17px" onclick="openTab('21-topic', '21-topic-4')" src="/season2025/static/_content/21-pop-1-text-4.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:547px;left:8px" onclick="openTab('21-topic', '21-topic-6')" src="/season2025/static/_content/21-pop-1-text-6.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:657px;left:56px" onclick="openTab('21-topic', '21-topic-7')" src="/season2025/static/_content/21-pop-1-text-7.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:748px;left:56px" onclick="openTab('21-topic', '21-topic-8')" src="/season2025/static/_content/21-pop-1-text-8.png" />
            <div class="abs contentLinkNone pointer" style="top:748px;left:1152px;width:41px;height:42px;" onclick="closeTab('21-topic', '21-topic-5')"></div>
          </div>


          <!-- topic 6 -->


          <div id="21-topic-6" class="21-topic hidden noclick">
            <img class="abs halfScale 21-pop-7" style="top:27px;left:50px;" src="/season2025/static/_content/21-pop-7.png"/>
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:116px;left:0px" onclick="openTab('21-topic', '21-topic-1')" src="/season2025/static/_content/21-pop-1-text-1.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:206px;left:20px" onclick="openTab('21-topic', '21-topic-2')" src="/season2025/static/_content/21-pop-1-text-2.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:296px;left:18px" onclick="openTab('21-topic', '21-topic-3')" src="/season2025/static/_content/21-pop-1-text-3.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:366px;left:17px" onclick="openTab('21-topic', '21-topic-4')" src="/season2025/static/_content/21-pop-1-text-4.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:476px;left:18px" onclick="openTab('21-topic', '21-topic-5')" src="/season2025/static/_content/21-pop-1-text-5.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:657px;left:56px" onclick="openTab('21-topic', '21-topic-7')" src="/season2025/static/_content/21-pop-1-text-7.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:748px;left:56px" onclick="openTab('21-topic', '21-topic-8')" src="/season2025/static/_content/21-pop-1-text-8.png" />
              <div class="abs contentLinkNone pointer" style="top:748px;left:1152px;width:41px;height:42px;" onclick="closeTab('21-topic', '21-topic-6')"></div>
            </div>


          <!-- topic 7 -->


          <div id="21-topic-7" class="21-topic hidden noclick">
            <img class="abs halfScale 21-pop-8" style="top:27px;left:50px;" src="/season2025/static/_content/21-pop-8.png"/>
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:116px;left:0px" onclick="openTab('21-topic', '21-topic-1')" src="/season2025/static/_content/21-pop-1-text-1.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:206px;left:20px" onclick="openTab('21-topic', '21-topic-2')" src="/season2025/static/_content/21-pop-1-text-2.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:296px;left:18px" onclick="openTab('21-topic', '21-topic-3')" src="/season2025/static/_content/21-pop-1-text-3.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:366px;left:17px" onclick="openTab('21-topic', '21-topic-4')" src="/season2025/static/_content/21-pop-1-text-4.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:476px;left:18px" onclick="openTab('21-topic', '21-topic-5')" src="/season2025/static/_content/21-pop-1-text-5.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:547px;left:8px" onclick="openTab('21-topic', '21-topic-6')" src="/season2025/static/_content/21-pop-1-text-6.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:748px;left:56px" onclick="openTab('21-topic', '21-topic-8')" src="/season2025/static/_content/21-pop-1-text-8.png" />
            <div class="abs contentLinkNone pointer" style="top:748px;left:1152px;width:41px;height:42px;" onclick="closeTab('21-topic', '21-topic-7')"></div>
          </div>


          <!-- topic 8 -->


          <div id="21-topic-8" class="21-topic hidden noclick">
            <img class="abs halfScale 21-pop-9" style="top:27px;left:50px;" src="/season2025/static/_content/21-pop-9.png"/>
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:116px;left:0px" onclick="openTab('21-topic', '21-topic-1')" src="/season2025/static/_content/21-pop-1-text-1.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:206px;left:20px" onclick="openTab('21-topic', '21-topic-2')" src="/season2025/static/_content/21-pop-1-text-2.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:296px;left:18px" onclick="openTab('21-topic', '21-topic-3')" src="/season2025/static/_content/21-pop-1-text-3.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:366px;left:17px" onclick="openTab('21-topic', '21-topic-4')" src="/season2025/static/_content/21-pop-1-text-4.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:476px;left:18px" onclick="openTab('21-topic', '21-topic-5')" src="/season2025/static/_content/21-pop-1-text-5.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:547px;left:8px" onclick="openTab('21-topic', '21-topic-6')" src="/season2025/static/_content/21-pop-1-text-6.png" />
            <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click" style="top:657px;left:56px" onclick="openTab('21-topic', '21-topic-7')" src="/season2025/static/_content/21-pop-1-text-7.png" />
            <div class="abs contentLinkNone pointer" style="top:748px;left:1152px;width:41px;height:42px;" onclick="closeTab('21-topic', '21-topic-8')"></div>
          </div>
        </div>


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();
          pg21Anim.staggerFromTo(cOf("21-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 0.2, 1)
        }

        function showTwentyOnePopOne(){
          showOverlay('21-pop-1');
        }

        function closeTwentyOnePopOne() {
          closeTab('21-topic', '21-topic-1'); 
          closeTab('21-topic', '21-topic-2'); 
          closeTab('21-topic', '21-topic-3'); 
          closeTab('21-topic', '21-topic-4'); 
          closeTab('21-topic', '21-topic-5'); 
          closeTab('21-topic', '21-topic-6'); 
          closeTab('21-topic', '21-topic-7'); 
          closeTab('21-topic', '21-topic-8');
          hideOverlay('21-pop-1');
        }

        function onPageLeave() {
        pg21Anim.stop();
        removeContentLinks();
        closeTwentyOnePopOne();
        }
      `,
      "searchText": ""
      }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 22-title" style="top:50px;left:49px" src="/season2025/static/_content/22-title-1.png" />
        <img class="halfScale 22-logo" style="top:45px;left:836px" src="/season2025/static/_content/22-logo-1.png" />
        <img class="halfScaleC 22-arrow" style="top:564px;left:36px" src="/season2025/static/_content/22-arrow-1.png" />


        <!-- click 1 -->

        <img class="abs halfScale halfpulse animatedpulse pointer 22-num" style="top:409px;left:55px" onclick="showTwentyTwoPopOne()" src="/season2025/static/_content/22-num-1.png" />

        <div id="22-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 22-box-bg" style="top:431px;left:724px;" src="/season2025/static/_content/22-box-bg.png"/>
          <img class="abs halfScale 22-pop-1" style="top:384px;left:92px;" src="/season2025/static/_content/22-pop-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:566px;left:1166px;width:37px;height:37px;" onclick="hideOverlay('22-pop-1')"></div>

          <!-- animations -->
          <img class="abs halfScale 22-box-icons" style="top:483px;left:911px;" src="/season2025/static/_content/22-box-1.png"/>
          <img class="abs halfScale 22-box-icons" style="top:483px;left:985px;" src="/season2025/static/_content/22-box-2.png"/>
          <img class="abs halfScale 22-box-icons" style="top:483px;left:1060px;" src="/season2025/static/_content/22-box-3.png"/>
          <img class="abs halfScale 22-box-icons" style="top:483px;left:1133px;" src="/season2025/static/_content/22-box-4.png"/>
        </div>


        <!-- click 2 -->

        <img class="abs halfScale halfpulse animatedpulse pointer 22-num" style="top:495px;left:50px" onclick="showTwentyTwoPopTwo()" src="/season2025/static/_content/22-num-2.png" />

        <div id="22-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 22-box-bg" style="top:515px;left:723px;" src="/season2025/static/_content/22-box-bg.png"/>
          <img class="abs halfScale 22-pop-2" style="top:469px;left:96px;" src="/season2025/static/_content/22-pop-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:649px;left:1162px;width:37px;height:37px;" onclick="hideOverlay('22-pop-2')"></div>

          <!-- animations -->
          <img class="abs halfScale 22-box-icons" style="top:569px;left:910px;" src="/season2025/static/_content/22-box-1.png"/>
          <img class="abs halfScale 22-box-icons" style="top:569px;left:985px;" src="/season2025/static/_content/22-box-2.png"/>
          <img class="abs halfScale 22-box-icons" style="top:569px;left:1060px;" src="/season2025/static/_content/22-box-3.png"/>
          <img class="abs halfScale 22-box-icons" style="top:569px;left:1133px;" src="/season2025/static/_content/22-box-4.png"/>
        </div>


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();
          pg22Anim.fromTo(cOf("22-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1)
          .fromTo(cOf("22-logo"), 0.6, {opacity:0, y:30}, {opacity:1, y:0}, 1.15)
        }

        function showTwentyTwoPopOne() {
          showOverlay('22-pop-1')
          pg22Anim = new TimelineMax();
          pg22Anim.fromTo(cOf("22-box-bg"), 0.5, {opacity:0, y:-35}, {opacity:1, y:0}, 0.8)
          .staggerFromTo(cOf("22-box-icons"), 0.5, {opacity:0, x:45}, {opacity:1, x:0}, 0.2, 1.1);
        }
      
        function closeTwentyTwoPopOne(){
          hideOverlay('22-pop-1')
        }

        function showTwentyTwoPopTwo() {
          showOverlay('22-pop-2')
          pg22Anim = new TimelineMax();
          pg22Anim.fromTo(cOf("22-box-bg"), 0.5, {opacity:0, y:-35}, {opacity:1, y:0}, 0.8)
          .staggerFromTo(cOf("22-box-icons"), 0.5, {opacity:0, x:45}, {opacity:1, x:0}, 0.2, 1);
        }
      
        function closeTwentyTwoPopTwo(){
          hideOverlay('22-pop-2')
        }

        function onPageLeave() {
          pg22Anim.stop();
          closeTwentyTwoPopOne();
          closeTwentyTwoPopTwo();
          removeContentLinks();
        }
      `,
      "searchText": ""
      }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
      
        <img class="halfScale 23-title" style="top:50px;left:49px" src="/season2025/static/_content/23-title-1.png" />


        <div class="contentLinkNone" onclick="Publish.goToPage(3);"style="top:855px; left:27px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top:855px; left:135px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(10);" style="top:855px; left:245px; width:95px; height:17px; transform: skewX(-20deg);"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(14);" style="top:855px; left:355px; width:95px; height:17px; transform: skewX(-20deg);"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim.fromTo(cOf("23-title"), 0.5, {opacity:0, x:60}, {opacity:1, x:0}, 1)
        }

        function onPageLeave() {
          pg23Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": ""
      }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `

      <div class="addContentLink" style="top:130px;left:48px;width:212px;height:16px">
        <a href="mailto:purpose@sailgp.com" target="_blank"></a>
      </div>

      <div class="addContentLink" style="top:240px;left:48px; width:83px; height:14px;">
        <a href="https://www.sailgp.com" target="_blank"></a>
      </div>

      <div class="addContentLink" style="top:258px;left:48px; width:67px; height:14px;">
        <a href="https://x.com/SailGP?lang=en" target="_blank"></a>
      </div>
            
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {     
          removeContentLinks();
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }

      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }

      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'addContentLink'
        })
      }

      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'contentLinkThree addContentLinkThree'
        })
      }

      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }

      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function openPop(id) {
        ele = idOf(id);
        ele.className = "visible"
      }

      function closePop(id) {
        ele = idOf(id);
        ele.className = "hidden noclick"
      }

      function openTab(klass, id) {
        k = cOf(klass);
        ele = idOf(id);

        for(var i=0; i<k.length; i++) {
          k[i].className = klass + " hidden noclick";
        }
        ele.className = klass + " visible"
      }

      function closeTab(klass, id) {
        k = cOf(klass);
        ele = idOf(id);

        ele.className = klass + " hidden noclick"
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function animateNumbers(klass, delay = 1000, stagger = 0.3) {
        numbers = cOf(klass)

        setTimeout(function() {
          for (let i = 0; i < numbers.length; i++) {
            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])
          }
        }, delay * 1000)
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }



// WEBPACK FOOTER //
// ./src/document.js